import { IInventoryPage } from '../../../inventory-page.interface';


export const UPLOAD_POD_DESIGN_MANAGEMENT_PAGE: IInventoryPage = {
	'route': '/upload/pod/design-management',
	'title': 'Designs',
	'uiReference': [
		'Search by listings',
		'Open search options',
		'Quick design filters',
		'Sorting',
		'Designs or listings',
		'Search by:',
		'Specific Search',
		'Show Details',
		'Newest',
		'Recently Edited',
		'No Listing',
		'Show Duplicates',
		'Advanced Options',
		'Loading designs',
		'of designs loaded',
		'Load more',
		'Refine library',
		'Advanced filters',
		'Filter by upload state, listing data, platforms, colors, and image dimensions.',
		'Reset filters',
		'Design Imported',
		'Listing Created / Edited',
		'Types',
		'Color',
		'Marketplaces',
		'Products',
		'Collection',
		'Categories',
		'All',
		'Design library',
		'Storage',
		'designs',
		'GB of GB Used ()',
		'Add designs Import Listings & Images',
		'Loading...',
		'Sorry, there was an internal error. Please contact support.',
		'Open AI Design Editor',
		'NEW',
		'Imported'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/design-management/design-management-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/design-management/design-management.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/design-management/design-management.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/design-management/design-management.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/shared/data-import/data-import.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/shared/data-import/data-import.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/design-management/views/design-view/scroll-view/scroll-view.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/design-management/views/design-view/scroll-view/scroll-view.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/info-card/info-card.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/info-card/info-card.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/design-management/views/design-view/grid-view/grid-view.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/design-management/views/design-view/grid-view/grid-view.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/api-loading-card/api-loading-card.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/api-loading-card/api-loading-card.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/design-management/designs/design-card/design-card.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/design-management/designs/design-card/design-card.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/design-management/designs/design-card/design-card.component.html'
	],
	'aliases': []
};
